import _ from 'underscore';
import $ from 'jquery';
import Router from 'root/router';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modal from 'root/module/modal';
import Widget_Code from 'view/widget_code';
import View_Step_Edit from 'view/widget_studio/step_edit';
import View_Widget_Preview from 'view/widget_studio/widget_preview';
import View_Launcher_Preview from 'view/widget_studio/launcher_preview';
import View_Audience from 'view/widget_studio/audience';
import View_Project_Name from 'view/project/name_inline_edit';
import View_Widget_Demo from 'view/widget_demo';
import View from 'view/base';
import Model_Widget_Setting from 'model/widget_setting';
import Modals from 'root/modals';

export default View.extend({
    className: 'widget-studio',

    step: 'design', // design, audience, install

    views: {
        audience: {},
        widget_code: {},
        step_edit: {},
        widget_preview: {},
        widget_demo: {},
        launcher_preview: {},
        project_name: {}
    },

    events: {
        'click .form-steps > span'        : 'onSelectStep',
        'click .help-btn'                 : 'onHelp',
        'click .widget-save'              : 'onWidgetSave',
        'click .widget-done'              : 'onWidgetDone',
        'click .widget-templates'         : 'onWidgetTemplate',
        'click .demo-address-bar-refresh' : 'onRefeshDemo',
        'click .widget-migrate'           : 'onMigrate'
    },

    dom_handlers: {
        onSelectStep: function(e) {
            var step_next = $(e.currentTarget).data('val');

            if (this.step === 'audience' && step_next === 'install' && !this.no_domain_confirmed) {
                var project_domains = this.views.audience.getDomains();

                if (!project_domains.length) {
                    Modal.open({
                        title: 'No domains added',
                        content: '<p>You need to add your app or website domains to install the code. However, you can still collect feedback using the browser extensions without installing the code.</p><p>Are you sure you don’t want to add any domains?</p>',
                        button: {
                            'Confirm': () => {
                                this.no_domain_confirmed = true;

                                this.goToStep(step_next);
                                Modal.close();
                            }
                        },
                        button_class: 'secondary'
                    });

                    return;
                }
            }

            if (step_next === 'demo' && this.isChanged()) {
                var modal = Modal.open({
                    title: 'Unsaved changes',
                    content: '<p>You have unsaved changes. To preview the changes, you will need to save them first.</p>',
                    button: {
                        'Save Changes': () => {
                            this.doSave(() => {
                                this.goToStep(step_next);
                                Modal.close();
                            });
                        }
                    },
                    button_html: '<button class="tertiary margin-right-12 donot-save" type="button">Don\'t save</button>'
                });

                modal.find('.donot-save').click((e) => {
                    this.goToStep(step_next);
                    Modal.close();
                });

                return;
            }

            this.goToStep(step_next);
        },

        onHelp: function(e) {
            UI.openLiveChat();
        },

        onWidgetSave: function(e) {
            if (!Cache.app.isAdmin()) {
                Modal.open({
                    title: 'Admin user required',
                    content: '<p>You do not have permission to edit this widget.</p>',
                    button: {
                        OK: () => {
                            Modal.close();
                        }
                    }
                });
                return;
            }

            Modal.confirm('<p>Are you sure you want to save these changes?</p>', () => {
                this.doSave();
            }, undefined, 'Yes, save');
        },

        onWidgetTemplate: function(e) {
            this.openTemplateGallery();
        },

        onWidgetDone: function(e) {
            if (!Cache.app.isAdmin()) {
                this.cancelEdit();
                return;
            }

            if (this.isChanged()) {
                const modal = Modal.open({
                    title: 'Save changes',
                    content: '<p>You have unsaved changes. Do you want to save them before exiting?</p>',
                    button: {
                        'Save Changes': () => {
                            Modal.close();
                            this.doSave();
                            this.cancelEdit();
                        },
                    },
                    button_html: '<button class="tertiary margin-right-12 donot-save" type="button">Don\'t Save</button>'
                });

                modal.find('.donot-save').click((e) => {
                    Modal.close();
                    this.cancelEdit();
                });
            } else {
                this.cancelEdit();
            }
        },

        onRefeshDemo: function() {
            this.$el.find('.demo-window iframe').get(0).contentWindow.postMessage('userback_reload');
        },

        onMigrate: function() {
            Modals.migrateWidget(this.model.id);
        }
    },

    event_handlers: {
        // this event is triggered when the widget settings are changed in the UI
        onWidgetChange: function(model) {
            this.updateSaveBtnStatus();

            var ignore_attributes = [
                // widget
                'device_type',
                'video_time',
                'trigger_type',
                'page_load_delay',
                'capture_console_log',
                'capture_console_error',
                'capture_console_warn',
                'capture_console_info',
                'capture_console_debug',
                'capture_network',
                'capture_event',
                'auto_screenshot',
                'direct_to_bug',
                'direct_to_general',
                'direct_to_feature_request',
                'user_segment',

                // widget setting
                'rating_mandatory',
                'name_field_mandatory',
                'email_field_mandatory',
                'title_field_mandatory',
                'comment_field_mandatory',
                'category_field_mandatory',
                'priority_field_mandatory',
                'assignee_field_mandatory',
                'custom_field_1_mandatory'
            ];

            var ignore_total = 0;
            Object.keys(model.changed).forEach((attribute_name) => {
                if (ignore_attributes.indexOf(attribute_name) !== -1) {
                    ignore_total++;
                }
            });

            if (ignore_total === Object.keys(model.changed).length) {
                return;
            }

            this.renderPreviewLauncher();
            this.renderPreviewForm();
        },

        onWidgetPreview: function() {
            this.renderPreviewForm();
        },

        onWidgetHighlight: function(layout_name) {
            if (layout_name) {
                this.$el.find('.userback-feedback-type-form[data-val="' + layout_name + '"]').addClass('highlighted');
            } else {
                this.$el.find('.userback-feedback-type-form').removeClass('highlighted');
            }
        },

        onPreviewNavSelect: function(component) {
            this.views.step_edit.openComponentSettings(component);
        }
    },

    openTemplateGallery: function(initial_template_code) {
        Modals.openTemplateGallery(initial_template_code, (template_code) => {
            this.trigger('Widget_Studio::TemplateSelected', template_code);
        }, undefined, 'feedback');
    },

    initialize: function(options) {
        this.onExit = options.onExit;
        this.template_code = options.template_code;
        this.hide_animation = !!options.hide_animation;

        if (['design', 'demo', 'audience', 'install'].indexOf(Router.getQueryString('s')) !== -1) {
            this.step = Router.getQueryString('s');
        }

        // widget model stored in the global state manager
        this.widget = Cache.widget.findWhere({project_id: Cache.default_project_id});

        this.widget_setting = {
            bug             : Cache.widget_setting.findWhere({widget_id: this.widget.id, widget_type: 'bug'}),
            feature_request : Cache.widget_setting.findWhere({widget_id: this.widget.id, widget_type: 'feature_request'}),
            general         : Cache.widget_setting.findWhere({widget_id: this.widget.id, widget_type: 'general'})
        };

        // unsaved widget settings are stored in this.model & this.model_setting
        this.model = this.widget.clone();

        this.model_setting = {
            bug             : null,
            feature_request : null,
            general         : null
        };

        // migrate
        _.each(this.model_setting, (model, widget_type) => {
            // widget setting model is not created for some old accounts
            if (!this.widget_setting[widget_type]) {
                var data = {
                    account_id       : this.widget.get('account_id'),
                    project_id       : this.widget.get('project_id'),
                    widget_id        : this.widget.id,
                    widget_type      : widget_type,
                    allow_screenshot : true,
                    allow_video      : true,
                    field_order      : 'email,name,title,comment,category,priority,assignee,custom_field_1',
                };

                if (widget_type === 'bug') {
                    data.title_field               = true;
                    data.rating_type               = '';
                    data.rating_help_message       = 'Tell us what\'s broken';
                    data.send_button_text          = 'Submit';
                    data.comment_field_placeholder = 'Describe the bug in detail';
                } else if (widget_type === 'feature_request') {
                    data.title_field               = true;
                    data.title_field_placeholder   = true;
                    data.rating_type               = 'Give your idea a name';
                    data.rating_help_message       = 'Tell us how we can improve';
                    data.send_button_text          = 'Submit';
                    data.title_field_placeholder   = 'Give your idea a name';
                    data.comment_field_placeholder = 'Tell us more, including the problem it solves';
                } else if (widget_type === 'general') {
                    data.rating_type               = 'star';
                    data.rating_help_message       = 'How would you rate your experience?';
                    data.send_button_text          = 'Send Feedback';
                }

                var new_model = new Model_Widget_Setting(data);
                Cache.widget_setting.add(new_model);

                this.widget_setting[widget_type] = new_model;
            }

            this.model_setting[widget_type] = this.widget_setting[widget_type].clone();
        });

        this.views.widget_code = new Widget_Code({
            show_all_projects: false,
            verify_project_id: Cache.default_project_id
        });

        this.views.audience = new View_Audience({
            model         : this.model,
            model_setting : this.model_setting
        });

        this.views.step_edit = new View_Step_Edit({
            widget        : this.widget,
            model         : this.model,
            model_setting : this.model_setting,
            main_tab      : options.main_tab
        });

        this.views.widget_preview = new View_Widget_Preview({
            model         : this.model,
            model_setting : this.model_setting
        });

        this.views.launcher_preview = new View_Launcher_Preview({
            model         : this.model
        });

        this.views.project_name = new View_Project_Name({
            model: Cache.getDefaultProject()
        });

        this.views.widget_demo = new View_Widget_Demo();

        // bind events
        this.listenTo(this.widget,                         'change',            this.updateSaveBtnStatus);
        this.listenTo(this.widget_setting.bug,             'change',            this.updateSaveBtnStatus);
        this.listenTo(this.widget_setting.general,         'change',            this.updateSaveBtnStatus);
        this.listenTo(this.widget_setting.feature_request, 'change',            this.updateSaveBtnStatus);
        this.listenTo(this.model,                          'change',            this.event_handlers.onWidgetChange);
        this.listenTo(this.model_setting.bug,              'change',            this.event_handlers.onWidgetChange);
        this.listenTo(this.model_setting.general,          'change',            this.event_handlers.onWidgetChange);
        this.listenTo(this.model_setting.feature_request,  'change',            this.event_handlers.onWidgetChange);
        this.listenTo(this.views.step_edit,                'Widget::Preview',   this.event_handlers.onWidgetPreview);
        this.listenTo(this.views.step_edit,                'Widget::Highlight', this.event_handlers.onWidgetHighlight);

        this.listenTo(this.views.audience, 'Domain:Change', this.updateSaveBtnStatus);

        this.listenTo(this.views.widget_preview, 'Nav:Select', this.event_handlers.onPreviewNavSelect);

        var templates = Cache.get('widget_templates') || [];

        if (this.template_code) {
            var template = templates.find((item) => item.template_code === this.template_code);

            if (template) {
                var template_data = _.omit(template, 'widget_settings', 'template_code', 'template_name', 'template_desc');

                if (!Cache.account.hasFeature('console_log')) {
                    var capture_console_methods = [
                        'capture_console_error',
                        'capture_console_warn',
                        'capture_console_info',
                        'capture_console_log',
                        'capture_console_debug',
                        'capture_network',
                    ];

                    capture_console_methods.forEach((item) => {
                        template_data[item] = false;
                    });

                    template_data.capture_event = false;
                }

                this.model.set(template_data);

                template.widget_settings.forEach((item) => {
                    if (this.model_setting[item.widget_type]) {
                        var setting_data = Object.assign({}, item);
                        this.model_setting[item.widget_type].set(setting_data);
                    }
                });
            } else {
                // Open the template gallery to preview if the template data doesn't exist (refresh page or share url).
                this.openTemplateGallery(this.template_code);
            }
        }
    },

    goToStep: function(step) {
        this.step = step;

        this.$el.find('.form-steps > span')
            .removeClass('active')
            .filter('[data-val="' + this.step + '"]').addClass('active');

        this.$el.find('.region-step').removeClass('active');
        this.$el.find('.region-step[data-val="' + this.step + '"]').addClass('active');

        if (step === 'demo') {
            this.views.widget_demo.start();
        }
    },

    doSave: function(on_success) {
        var submit_button = this.$el.find('.widget-save');
        submit_button.prop('disabled', true).addClass('loading');

        // project domains
        var project_domains = this.views.audience.getDomains();
        Cache.app.request({
            action: 'project/update',
            data: {
                project_id: Cache.default_project_id,
                project_domains: project_domains.length ? project_domains : ['']
            },
            success: (response) => {
                Cache.project_domain.where({project_id: Cache.default_project_id}).forEach((model) => {
                    Cache.project_domain.remove(model);
                });

                Cache.project_domain.add(response.project_domain);
            }
        });

        var widget_attributes = this.model.attributes;

         // clean up page condition
         let page_condition = this.views.audience.getPageCondition();
         try {
             page_condition = JSON.parse(page_condition);

             // get rid of empty conditions
             page_condition.conditions = page_condition.conditions.filter(condition => condition.type && condition.value);
         } catch (e) {
             page_condition = {
                 operator: 'or',
                 conditions: []
             };
         }

        // clean up widget attributes
        widget_attributes.page_condition = JSON.stringify(page_condition);

        // widget
        Cache.app.request({
            action: 'widget/save',
            data: {...widget_attributes,
                widget_setting_general         : this.model_setting.general.attributes,
                widget_setting_bug             : this.model_setting.bug.attributes,
                widget_setting_feature_request : this.model_setting.feature_request.attributes
            },
            success: (response) => {
                this.model.set(response.widget);
                this.widget.set(response.widget);

                response.widget_setting.forEach((data) => {
                    this.widget_setting[data.widget_type].set(data);
                    this.model_setting[data.widget_type].set(data);
                });

                // disable save button becasue the set call above will enable it
                submit_button.prop('disabled', true);

                UI.success('Widget settings updated');

                if (on_success) {
                    on_success();
                }
            },
            complete: () => {
                submit_button.removeClass('loading');
            }
        });

        // onboarding
        Cache.app.trackProjectOnboarding('edit_widget', 1);
    },

    warnUnsavedChanges: function(discard_callback) {
        Modal.open({
            title: 'Unsaved Changes',
            content: 'You have unsaved changes. Are you sure you want to discard them?',
            button: {
                'Yes, discard': () => {
                    discard_callback();
                }
            },
            text_link: {
                Cancel: (e) => {
                    e.preventDefault();
                    Modal.close();
                }
            }
        });
    },

    cancelEdit: function() {
        if (this.onExit) {
            this.onExit();
        }

        this.remove();
    },

    isChanged: function() {
        var is_widget_changed               = JSON.stringify(this.model.toJSON()) !== JSON.stringify(this.widget.toJSON());
        var is_bug_form_changed             = !this.widget_setting.bug             || JSON.stringify(this.model_setting.bug.toJSON())             !== JSON.stringify(this.widget_setting.bug.toJSON());
        var is_general_form_changed         = !this.widget_setting.general         || JSON.stringify(this.model_setting.general.toJSON())         !== JSON.stringify(this.widget_setting.general.toJSON());
        var is_feature_request_form_changed = !this.widget_setting.feature_request || JSON.stringify(this.model_setting.feature_request.toJSON()) !== JSON.stringify(this.widget_setting.feature_request.toJSON());
        var is_domain_changed               = this.views.audience.getDomains().join(',') !== Cache.project_domain.where({project_id: Cache.default_project_id}).map((model) => {
            return model.get('domain');
        }).join(',');

        return is_widget_changed || is_bug_form_changed || is_general_form_changed || is_feature_request_form_changed || is_domain_changed;
    },

    updateSaveBtnStatus: function() {
        this.$el.find('.widget-save').prop('disabled', !this.isChanged());
    },

    renderPreviewLauncher: function() {
        this.views.launcher_preview.render().$el.appendTo(this.$el.find('.region-preview-form'));
    },

    renderPreviewForm: function() {
        var render_success = this.views.step_edit.child_tab_selected === '#success';

        this.$el.find('.region-preview-form')
            .attr('data-modal', this.model.get('use_modal') ? 'true' : 'false')
            .attr('data-position', this.model.get('position'))
            .attr('data-style', this.model.get('style'));

        this.views.widget_preview.setLanguage(this.model.get('language'));
        this.views.widget_preview.setFormType(this.views.step_edit.form_selected);
        this.views.widget_preview.render(render_success).$el.appendTo(this.$el.find('.region-preview-form'));
    },

    render: function() {
        if (this.hide_animation) {
            this.$el.addClass('hide-animation');
        }

        var content =
        '<div class="region-header">' +
            '<div class="region-project-name"></div>' +
            '<div>' +
                '<div class="form-steps badge-group-tertiary">' +
                    '<span class="min" data-val="design">Design</span>' +
                    '<span class="min" data-val="audience">Target</span>' +
                    '<span class="min" data-val="demo">Preview</span>' +
                    '<span class="min" data-val="install">Install</span>' +
                '</div>' +
            '</div>' +
            '<div class="region-save-btns">' +
                (!this.model.isNextGen() ?
                '<button type="button" class="widget-migrate shiny small margin-right-16"><span>New version is available</span></button>' : '') +

                '<button type="button" class="help-btn margin-right-16"><i class="fa-regular fa-question-circle"></i></button>' +
                '<button type="button" class="widget-save primary small min margin-right-8" disabled>Save</button>' +
                '<button type="button" class="widget-done  btn-close"><i class="fa-regular fa-xmark"></i></button>' +
            '</div>' +
        '</div>' +
        '<div class="region-step" data-val="design">' +
            '<div class="region-widget-preview">' +
                '<div>' +
                    '<div class="region-preview-action-bar">' +
                        '<button class="widget-templates tertiary small min">Templates</button>' +
                    '</div>' +
                    '<div class="region-preview-form"></div>' +
                    '<div class="region-preview-launcher"></div>' +
                '</div>' +
            '</div>' +
            '<div class="region-widget-settings">' +
                '<div class="setting-step" data-step="edit"></div>' +
            '</div>' +
        '</div>' +
        '<div class="region-step" data-val="audience"></div>' +
        '<div class="region-step" data-val="demo"></div>' +
        '<div class="region-step" data-val="install"></div>';

        this.$el.html(content);

        this.views.project_name.render().$el.appendTo(this.$el.find('.region-project-name'));
        this.views.step_edit.render().$el.appendTo(this.$el.find('.setting-step[data-step="edit"]'));
        this.views.audience.render().$el.appendTo(this.$el.find('.region-step[data-val="audience"]'));
        this.views.widget_demo.render().$el.appendTo(this.$el.find('.region-step[data-val="demo"]'));
        this.views.widget_code.render().$el.appendTo(this.$el.find('.region-step[data-val="install"]'));

        this.renderPreviewLauncher();
        this.renderPreviewForm();

        this.goToStep(this.step);

        // Update save btn after the DOM appended to the Document.
        setTimeout(() => {
            this.updateSaveBtnStatus();
        }, 0);

        Cache.app.trackProjectOnboarding('edit_widget', 1);

        return this;
    }
});